import { render, staticRenderFns } from "./vsDialogTabsCustom.vue?vue&type=template&id=441bd7bd"
import script from "./vsDialogTabsCustom.vue?vue&type=script&lang=js"
export * from "./vsDialogTabsCustom.vue?vue&type=script&lang=js"
import style0 from "./vsDialogTabsCustom.vue?vue&type=style&index=0&id=441bd7bd&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441bd7bd')) {
      api.createRecord('441bd7bd', component.options)
    } else {
      api.reload('441bd7bd', component.options)
    }
    module.hot.accept("./vsDialogTabsCustom.vue?vue&type=template&id=441bd7bd", function () {
      api.rerender('441bd7bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsDialogCustom/vsDialogTabsCustom.vue"
export default component.exports